"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferReminderTemplateUpdateRequestSchema = exports.OfferReminderTemplateCreateRequestSchema = exports.OfferReminderTemplateListQuerySchema = exports.OfferReminderTemplateIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
const offers_1 = require("../../../../schemas/offers");
exports.OfferReminderTemplateIdPathParamsSchema = zod_1.z.object({ templateId: schemas_1.UUIDSchema });
exports.OfferReminderTemplateListQuerySchema = schemas_1.PaginationQuerySchema;
exports.OfferReminderTemplateCreateRequestSchema = offers_1.JobOfferreminderTemplateSchema.omit({ id: true, updatedAt: true });
exports.OfferReminderTemplateUpdateRequestSchema = exports.OfferReminderTemplateCreateRequestSchema.partial();
